export const closeLegalModal = () => ({
  type: 'CLOSE_LEGAL_MODAL',
});

export const openLegalModal = selectedModal => ({
  type: 'OPEN_LEGAL_MODAL',
  selectedModal,
});
